<template>
  <div class="tgmag-switch-group">
    <div class="tgmag-switch-labels">
      <label>{{ label }}</label>
      <p class="tgmag-switch-labels__sublabel">
        {{ sublabel }}
      </p>
    </div>
    <div class="tgmag-switch-buttons">
      <button
        :aria-label="`Decrease ${label} number`"
        class="tgmag-switch tgmag-switch--subtract"
        :class="[{ 'tgmag-switch--disabled': isDecrementDisabled }]"
        :disabled="isDecrementDisabled"
        @click="decrement()"
      >
        <img :src="icons.decrement" alt="-" />
      </button>
      <div class="tgmag-switch-input">
        {{ localValue }}
      </div>
      <button
        :aria-label="`Increase ${label} number`"
        class="tgmag-switch tgmag-switch--add"
        :class="[{ 'tgmag-switch--disabled': isIncrementDisabled }]"
        :disabled="isIncrementDisabled"
        @click="increment()"
      >
        <img :src="icons.increment" alt="+" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stepper",
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 9
    },
    label: {
      type: String,
      default: "Label"
    },
    sublabel: {
      type: String,
      default: "sublabel"
    }
  },
  data() {
    return {
      icons: {
        increment: null,
        decrement: null
      },
      localValue: 0
    };
  },
  created() {
    import("./increment.svg").then(data => {
      this.icons.increment = data.default;
    });
    import("./decrement.svg").then(data => {
      this.icons.decrement = data.default;
    });
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.localValue = value;
      }
    }
  },
  computed: {
    isIncrementDisabled() {
      return this.localValue === this.max;
    },
    isDecrementDisabled() {
      return this.localValue === this.min;
    }
  },
  methods: {
    increment() {
      if (this.localValue === this.max) return;
      this.localValue = this.localValue + 1;
      this.$emit("input", this.localValue);
    },
    decrement() {
      if (this.localValue === this.min) return;
      this.localValue = this.localValue - 1;
      this.$emit("input", this.localValue);
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/variables.scss";
.tgmag-switch-group {
  box-sizing: border-box;
  // margin: $base-padding * 2 $base-padding;
  display: flex;

  .tgmag-switch {
    appearance: none;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 48px;
    margin: 0;

    background-color: $input-button;
    border: 1px solid $secondary;

    cursor: pointer;

    span {
      padding: 0 $base-padding;
      font-size: $base-font-size * 2.5;
      color: $primary;
    }

    &:hover,
    &:focus {
      &:not(.tgmag-switch--active):not(.tgmag-switch--disabled) {
        border: 1px solid $input-active;
      }
    }

    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &--active {
      background-color: $selected;
      border: 1px solid $success;
      font-weight: theme-weight("demi");
    }
    &--disabled {
      background-color: $input-button-inactive;
      border: 1px solid $support-2;
      color: $support-1;
      span {
        color: $support-1;
      }
    }
  }
}
.tgmag-switch-buttons {
  display: flex;
  flex: 1;
  align-items: center;
  max-width: 160px;
}
.tgmag-switch-input {
  box-sizing: border-box;
  border-right: 0;
  border-left: 0;
  border-radius: 0;
  line-height: 24px;
  height: 48px;
  min-width: 48px;
  text-align: center;
  user-select: none;
  pointer-events: none;
  padding: 12px 18px;
  min-width: 48px;
  border: 1px solid $secondary;
  border-left-width: 0;
  border-right-width: 0;
  color: $primary;
}
.tgmag-switch-labels {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  color: $primary;
  &__sublabel {
    margin: 0;
    font-size: $base-font-size * 1.75;
  }
}
</style>
